import { Component, Input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-dashboard-card',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './dashboard-card.component.html',
  styleUrl: './dashboard-card.component.scss'
})
export class DashboardCard {
  // public cardInfo = input<{ title: string, iconImg: string, iconImg2: string, percentage: string, isFooter: boolean, isSelect: boolean, status?: string, shareStatus: string,selectInitialValue?:string }>();
  // public footerInfo = input<{ currency: string, currencyStatus: string }>();
  // public clickBtn = input<Function>();

  @Input() cardInfo!: { title: string, iconImg: string, iconImg2: string, percentage: string, isFooter: boolean, isSelect: boolean, status?: string, shareStatus: string,selectInitialValue?:string };
  @Input() footerInfo!: { currency: string, currencyStatus: string };
  @Input() clickBtn!: Function;
}
